/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import styled from 'styled-components';
import {
  Button,
  Modal,
  Radio,
  RadioGroup,
  Space,
  Text,
  Title,
} from 'components';
import { DASHBOARD_LISTING_STORAGE_KEYS } from 'utils';
import { AssumeUser } from './types';

interface MlsNumberSelectionModalProps {
  users: AssumeUser[];
  visible: boolean;
  onModalClose: () => void;
}

const MlsNumberSelectionModal: React.FC<MlsNumberSelectionModalProps> = ({
  users,
  visible,
  onModalClose,
}) => {
  const [selectedId, setSelectedId] = React.useState<string>();

  return (
    <Modal
      width={346}
      centered
      footer={null}
      open={visible}
      onCancel={onModalClose}
    >
      <StyledModal>
        <Title level={3}>Select MLS Member ID</Title>
        <StyledTextContainer>
          <StyledText type="secondary">
            This user is associated with mulitple BrokerBay accounts. Please
            select the MLS Member ID of the account you would like to access.
          </StyledText>
        </StyledTextContainer>
        <RadioGroup
          onChange={e => setSelectedId(e.target.value)}
          value={selectedId}
        >
          <Space direction="vertical">
            {users.map(user => (
              <Radio key={user.id} value={user.id}>
                {user.mlsNumber}
              </Radio>
            ))}
          </Space>
        </RadioGroup>
        <StyledButton
          onClick={() => {
            // Clear dashboard listing storage keys on assumption
            localStorage.removeItem(DASHBOARD_LISTING_STORAGE_KEYS.status);
            localStorage.removeItem(
              DASHBOARD_LISTING_STORAGE_KEYS.availability,
            );
            window.location.href = `/brokerbay_admin/assume/${selectedId}?assumeBySelection=User Email`;
          }}
          disabled={!selectedId}
          type="primary"
        >
          Continue
        </StyledButton>
      </StyledModal>
    </Modal>
  );
};

export default MlsNumberSelectionModal;

const StyledModal = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledTextContainer = styled.div`
  width: 292px;
  margin: 24px 3px;
  text-align: center !important;
`;

const StyledText = styled(Text)`
  font-size: 12px;
`;

const StyledButton = styled(Button)`
  width: 100%;
  height: 40px;
  margin-top: 24px;
`;
